/* Pool Busters — Commercial Aquatic Division (pb-cm-*)
   Progressive enhancement only: every section is complete and readable without
   this file. It adds link handling, the sub-nav state, the circulation
   explorer, request routing and form validation. Exposes only window.PB_CM. */
(function () {
  'use strict';
  if (window.PB_CM) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------- links navigate themselves ----------
     The live theme binds a delegated handler that calls preventDefault() on
     every anchor. Each .pbcm root handles its own links first (bubbling reaches
     the root before the document), so hash links scroll and real links go. */
  function scrollToId(id, focus) {
    var el = document.getElementById(id);
    if (!el) return false;
    el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    if (history.replaceState) history.replaceState(null, '', '#' + id);
    if (focus) {
      if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '-1');
      el.focus({ preventScroll: true });
    }
    return true;
  }
  function onLink(e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || e.defaultPrevented) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0 || a.target === '_blank') return;
    var href = a.getAttribute('href');
    if (!href) return;
    var hashAt = href.indexOf('#');
    var samePage = href.charAt(0) === '#' || (hashAt > 0 && href.slice(0, hashAt) === location.pathname);
    if (samePage) {
      var id = href.slice(hashAt + 1);
      var route = a.getAttribute('data-pbcm-route');
      if (route) setRoute(route);
      /* a link can also open a specific tab (e.g. a capability) before scrolling */
      var tabId = a.getAttribute('data-pbcm-tab');
      var tab = tabId && document.getElementById(tabId);
      if (tab) tab.click();
      if (scrollToId(id, !!route)) e.preventDefault();
      return;
    }
    e.preventDefault();
    window.location.href = a.href;
  }

  /* ---------- sub-nav: mark the section in view ---------- */
  function initSubnav() {
    var nav = document.querySelector('.pbcm-subnav');
    if (!nav || !('IntersectionObserver' in window)) return;
    var links = $$('.pbcm-subnav__list a', nav);
    var map = {};
    links.forEach(function (a) { map[a.getAttribute('href').slice(1)] = a; });
    var current = null;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var a = map[en.target.id] || null;
        if (a === current) return;
        if (current) current.removeAttribute('aria-current');
        current = a;
        if (!a) return;   /* a section the menu does not list: nothing is marked */
        a.setAttribute('aria-current', 'true');
        var list = a.parentNode.parentNode;
        var l = a.offsetLeft, r = l + a.offsetWidth;
        if (l < list.scrollLeft || r > list.scrollLeft + list.clientWidth) list.scrollLeft = Math.max(0, l - 24);
      });
    }, { rootMargin: '-40% 0px -55% 0px' });
    $$('.pbcm-page > section[id]').forEach(function (s) { io.observe(s); });
  }

  /* ---------- circulation explorer ---------- */
  var ZONES = {
    all: [],
    flow: ['suction', 'pump', 'filter', 'flowmeter', 'heater', 'returns'],
    quality: ['filter', 'flowmeter', 'chemical', 'returns', 'pump'],
    chemical: ['chemical', 'flowmeter', 'filter'],
    heat: ['heater', 'pump', 'flowmeter'],
    suction: ['suction', 'pump', 'pool'],
    loss: ['pool', 'suction', 'returns']
  };
  function initExplorer() {
    $$('[data-pbcm-explorer]').forEach(function (root) {
      var stage = root.querySelector('.pbcm-hyd__stage');
      var chips = $$('[data-symptom]', root);
      var zoneEls = $$('[data-zone]', stage);
      var panels = $$('[data-panel]', stage);
      function show(key) {
        var on = ZONES[key] || [];
        stage.setAttribute('data-active', key);
        chips.forEach(function (c) { c.setAttribute('aria-pressed', String(c.getAttribute('data-symptom') === key)); });
        zoneEls.forEach(function (z) { z.classList.toggle('is-on', on.indexOf(z.getAttribute('data-zone')) > -1); });
        panels.forEach(function (p) { p.hidden = p.getAttribute('data-panel') !== key; });
      }
      chips.forEach(function (c) { c.addEventListener('click', function () { show(c.getAttribute('data-symptom')); }); });
      /* Flow dashes move only while the drawing is on screen, never under reduced motion. */
      var fig = stage.querySelector('.pbcm-schem');
      if (fig && !reduce && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) { fig.classList.toggle('is-moving', en[0].isIntersecting); }, { threshold: 0.15 }).observe(fig);
      }
    });
  }

  /* ---------- request routing ---------- */
  var form = null;
  function setRoute(route) {
    if (!form) return;
    var r = form.querySelector('input[data-route="' + route + '"]');
    if (r) { r.checked = true; syncGroups(); }
  }
  function syncGroups() {
    var checked = form.querySelector('input[data-route]:checked');
    var route = checked ? checked.getAttribute('data-route') : '';
    $$('[data-need-group]', form).forEach(function (g) {
      var show = (' ' + g.getAttribute('data-need-group') + ' ').indexOf(' ' + route + ' ') > -1;
      g.hidden = !show;
      /* Hidden groups must not send stale answers from a previous choice. */
      $$('input', g).forEach(function (i) { i.disabled = !show; });
    });
    syncUrgent();
    var msg = form.querySelector('[data-msg-for="route"]');
    if (msg && route) msg.hidden = true;
  }
  function syncUrgent() {
    var box = form.querySelector('[data-pbcm-urgent]');
    var u = form.querySelector('input[data-urgent]');
    if (box && u) box.hidden = !(u.checked && !u.disabled);
  }
  function fieldMsg(input) {
    var wrap = input.closest('.pbcm-f');
    return wrap ? wrap.querySelector('.pbcm-f__msg') : null;
  }
  function validate() {
    var first = null;
    var route = form.querySelector('input[data-route]:checked');
    var rmsg = form.querySelector('[data-msg-for="route"]');
    if (!route) { if (rmsg) rmsg.hidden = false; first = first || form.querySelector('input[data-route]'); }
    $$('input[required]:not([data-route]), textarea[required]', form).forEach(function (i) {
      if (!checkField(i) && !first) first = i;
    });
    return first;
  }
  function checkField(i) {
    var v = i.value.trim();
    var bad = !v || (i.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) || (i.type === 'tel' && v.replace(/\D/g, '').length < 7);
    i.setAttribute('aria-invalid', String(bad));
    var m = fieldMsg(i);
    if (m) m.hidden = !bad;
    return !bad;
  }
  function initForm() {
    form = document.getElementById('pbcm-form');
    if (!form) return;
    if (form.tagName !== 'FORM') form = form.querySelector('form') || form;
    syncGroups();
    form.addEventListener('change', function (e) {
      if (e.target.hasAttribute('data-route')) syncGroups();
      if (e.target.name === 'contact[Operating status]') syncUrgent();
    });
    /* Clear a field's error while the person types, never on blur: an error
       message collapsing on blur moves the Send button out from under a click
       that is already in progress, and the click is lost. */
    form.addEventListener('input', function (e) {
      if (e.target.getAttribute('aria-invalid') === 'true') {
        var i = e.target, v = i.value.trim();
        var fixed = v && !(i.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) && !(i.type === 'tel' && v.replace(/\D/g, '').length < 7);
        if (fixed) checkField(i);
      }
    });
    form.addEventListener('submit', function (e) {
      var first = validate();
      if (first) {
        e.preventDefault();
        first.focus();
        first.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      }
    });
    var sent = document.querySelector('[data-pbcm-sent]');
    if (sent) { sent.scrollIntoView({ block: 'center' }); sent.focus({ preventScroll: true }); }
  }

  /* ---------- phone sticky bar ----------
     position:fixed is relative to any transformed ancestor, and Debut transforms
     its page container, so the bar is moved to <body>. It moves inside its own
     .pbcm wrapper so the colour tokens it depends on still resolve. */
  function initSticky() {
    var bar = document.querySelector('[data-pbcm-sticky]');
    if (!bar) return;
    var wrap = document.createElement('div');
    wrap.className = 'pbcm pbcm-sticky-host';
    wrap.appendChild(bar);
    document.body.appendChild(wrap);
    document.body.classList.add('pbcm-has-sticky');
    wrap.addEventListener('click', onLink);
    var sel = bar.getAttribute('data-hide-when');
    var target = sel && document.querySelector(sel);
    if (target && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { bar.classList.toggle('is-away', en[0].isIntersecting); }, { threshold: 0.02 }).observe(target);
    }
  }

  /* ---------- audience tabs (changes only when a person chooses) ---------- */
  function initTabs() {
    $$('[data-pbcm-tabs]').forEach(function (root) {
      var tabs = $$('[role="tab"]', root);
      function select(tab, focus) {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', String(on));
          t.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.classList.toggle('is-active', on);
        });
        if (focus) tab.focus();
      }
      /* Hidden panels' photos load before anyone clicks: once the tab group is
         near the viewport, switch them to eager so a tab never opens on a blank. */
      var warm = function () { $$('img[loading="lazy"]', root).forEach(function (im) { im.loading = 'eager'; }); };
      if ('IntersectionObserver' in window) {
        var wio = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { warm(); wio.disconnect(); } }, { rootMargin: '600px 0px' });
        wio.observe(root);
      } else { warm(); }
      /* and in any case shortly after the page has finished loading, so a jump
         link that skips past a tab group never leaves its photos unloaded */
      var late = function () { setTimeout(warm, 300); };
      if (document.readyState === 'complete') late(); else window.addEventListener('load', late);
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(t, false); });
        t.addEventListener('keydown', function (e) {
          var k = e.key, j = null;
          if (k === 'ArrowRight') j = (i + 1) % tabs.length;
          else if (k === 'ArrowLeft') j = (i - 1 + tabs.length) % tabs.length;
          else if (k === 'Home') j = 0;
          else if (k === 'End') j = tabs.length - 1;
          if (j === null) return;
          e.preventDefault();
          select(tabs[j], true);
        });
      });
    });
  }

  function init() {
    $$('.pbcm').forEach(function (root) { root.addEventListener('click', onLink); });
    initSticky();
    initTabs();
    initSubnav();
    initExplorer();
    initForm();
  }
  window.PB_CM = { version: '1.0.0', setRoute: setRoute };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
